import { FormLabel } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"; // Added Card imports
import { RentalFormValues } from "@/hooks/useRentalForm";
import { Customer } from "@/types/models";
import CustomerSelector from "./CustomerSelector";

interface CustomerInfoFormProps {
  form: UseFormReturn<RentalFormValues>;
  selectedCustomer: Customer | null;
  onCustomerSelect: (customer: Customer | null) => void;
  searchTerm: string;
  onSearchChange: (search: string) => void;
}

const CustomerInfoForm = ({ 
  selectedCustomer, 
  onCustomerSelect, 
  searchTerm, 
  onSearchChange 
}: CustomerInfoFormProps) => {
  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold">Información Cliente</h2>      
      <div className="space-y-4">
        <div className="space-y-2">
          <FormLabel>Cliente</FormLabel>
          <CustomerSelector
            selectedCustomer={selectedCustomer}
            onCustomerSelect={onCustomerSelect}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
          />
        </div>

        {selectedCustomer && (
          <Card className="mt-2">
            <CardHeader>
              <CardTitle>Información del Cliente: {selectedCustomer.id_card}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div>
                  <p className="text-lg font-semibold">{selectedCustomer.name}</p>
                  <p className="mt-1 text-sm text-gray-900">{selectedCustomer.phone}</p>
                </div>
              </div>
              {selectedCustomer.profile_photo_url && (
                <div className="mt-2 space-y-1">
                  <FormLabel>Foto de Cédula</FormLabel>
                  <div className="border rounded-lg p-4 bg-gray-50">
                    <img
                      src={selectedCustomer.profile_photo_url}
                      alt="Foto de cédula del cliente"
                      className="w-full max-w-sm mx-auto rounded-lg border shadow-sm"
                    />
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        )}
      </div>
      <Separator />
    </div>
  );
};

export default CustomerInfoForm;
